import { render, staticRenderFns } from "./VerificacionCliente.vue?vue&type=template&id=3c47950b&scoped=true"
import script from "./VerificacionCliente.vue?vue&type=script&lang=js"
export * from "./VerificacionCliente.vue?vue&type=script&lang=js"
import style0 from "./VerificacionCliente.vue?vue&type=style&index=0&id=3c47950b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47950b",
  null
  
)

export default component.exports